import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import {
    Modal,
    Card,
    CardContent,
    CardActions,
    Grid,
    Typography,
    TextField,
    Switch,
    Button,
    colors
} from '@material-ui/core';
import { copy_special_date } from '../../../../api/API';

const useStyles = makeStyles(theme => ({
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        outline: 'none',
        boxShadow: theme.shadows[20],
        width: 700,
        maxHeight: '100%',
        overflowY: 'auto',
        maxWidth: '100%'
    },

    container: {
        marginTop: theme.spacing(3)
    },

    actions: {
        justifyContent: 'flex-end'
    },

    closeButton: {
        color: theme.palette.white,
        backgroundColor: "#000",
        '&:hover': {
            backgroundColor: "#000"
        }
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
}));

export default function CopyDate(props) {

    const { open, onClose, customer, property_id, className, ...rest } = props;

    const classes = useStyles();

    const [formState, setFormState] = useState({
        property_id: property_id
    });


    useEffect(() => {
        setFormState({
            property_id: property_id
        });
    }, []);
    const clearForm = () => {

    }
    const handleFieldChange = event => {
        event.persist();
        setFormState(formState => ({
            ...formState,
            [event.target.name]:
                event.target.type === 'checkbox'
                    ? event.target.checked
                    : event.target.value
        }));
    };

    const handleSubmit = async event => {
        event.preventDefault();

        if (!formState.copy_date) {
            alert("Please enter a date to copy from");
            return;
        }
        if (!formState.target) {
            alert("Please enter a target date");
            return;
        }
        if (!formState.title) {
            alert("Please give this date a title");
            return;
        }
        let response = await copy_special_date(formState);
        if (response) {
            onClose();
        }
    }

    return (
        <Modal
            onClose={onClose}
            open={open}
        >
            <Card
                {...rest}
                className={clsx(classes.root, className)}
            >
                <form onSubmit={handleSubmit}>
                    <CardContent>
                        <Typography
                            align="center"
                            gutterBottom
                            variant="h5"
                        >
                            Add Special Day
                    </Typography>
                        <h3>Copy from </h3>
                        <Grid
                            className={classes.container}
                            container
                            spacing={1}
                        >
                            <Grid
                                item
                                md={4}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Copy"
                                    name="copy_date"
                                    type="date"
                                    InputLabelProps={{ shrink: true }}
                                    onChange={handleFieldChange}
                                    value={formState.copy_date}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid
                                item
                                md={4}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="date"
                                    name="target"
                                    type="date"
                                    InputLabelProps={{ shrink: true }}
                                    onChange={handleFieldChange}
                                    value={formState.target}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid
                                item
                                md={4}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="name"
                                    name="title"
                                    onChange={handleFieldChange}
                                    value={formState.title}
                                    variant="outlined"
                                />
                            </Grid>

                        </Grid>
                    </CardContent>
                    <CardActions className={classes.actions}>
                        <Grid container>
                            <Grid item xs={12}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end'
                                }}
                            >
                                <Button
                                    className={classes.closeButton}
                                    onClick={onClose}
                                    variant="contained"
                                >
                                    <CloseIcon className={classes.leftIcon} />
                                    Close
                                </Button>
                                <Button
                                    className={classes.saveButton}
                                    type="submit"
                                    variant="contained"
                                    style={{
                                        marginLeft: 10
                                    }}
                                >
                                    <SaveIcon className={classes.leftIcon} />
                                    Save
                                </Button>
                            </Grid>
                            <Grid item xs={12} style={{
                                borderTop: "1px solid black",
                                marginTop: "10px",
                                paddingTop: "35px",
                                display: "flex",
                                justifyContent: "center"
                            }}>
                                <Link to={"/createspecialtimetable/" + property_id}>
                                    <Button
                                        variant="contained">
                                        <AddIcon className={classes.leftIcon} />
                                        Create New Timetable
                                    </Button>
                                </Link>

                            </Grid>

                        </Grid>

                    </CardActions>
                </form>
            </Card>
        </Modal>
    )
}
